import React from "react";
import { BsFileEarmarkExcel, BsFileEarmarkImage, BsFileEarmarkPdf } from "react-icons/bs";

const TYPE_META = {
	manifest: {
		label: "Book list",
		Icon: BsFileEarmarkExcel,
		pill: "bg-akgreen bg-opacity-10 text-akgreenest",
	},
	cover: {
		label: "Cover",
		Icon: BsFileEarmarkImage,
		pill: "bg-sky-50 text-sky-800",
	},
	pdf: {
		label: "PDF",
		Icon: BsFileEarmarkPdf,
		pill: "bg-orange-50 text-orange-800",
	},
};

const STATUS_META = {
	waiting: "text-gray-500",
	uploading: "text-akgreener",
	uploaded: "text-akgreenest",
	failed: "text-red-600",
	ready: "text-akgreenest",
};

export const formatFileSize = (bytes) => {
	const n = Number(bytes);
	if (!Number.isFinite(n) || n < 0) return null;
	if (n < 1024) return `${n} B`;
	const kb = n / 1024;
	if (kb < 1024) return `${kb < 10 ? kb.toFixed(1) : Math.round(kb)} KB`;
	const mb = kb / 1024;
	return `${mb < 10 ? mb.toFixed(1) : Math.round(mb)} MB`;
};

const FileChip = ({
	name,
	type = "cover",
	status,
	progress,
	error,
	sizeBytes,
	className = "",
}) => {
	const meta = TYPE_META[type] || TYPE_META.cover;
	const Icon = meta.Icon;
	const statusClass = STATUS_META[status] || "text-gray-600";

	return (
		<div
			className={`flex items-center gap-3 rounded-xl border border-gray-200 bg-white px-3 py-2.5 ${className}`}
		>
			<span
				className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-lg ${meta.pill}`}
				aria-hidden
			>
				<Icon className="h-5 w-5" />
			</span>
			<div className="min-w-0 flex-1">
				<div className="flex flex-wrap items-center gap-2">
					<p className="truncate text-sm font-medium text-gray-900">{name}</p>
					<span
						className={`rounded-full px-2 py-0.5 text-xs font-semibold uppercase tracking-wide ${meta.pill}`}
					>
						{meta.label}
					</span>
					{formatFileSize(sizeBytes) ? (
						<span className="text-xs font-medium tabular-nums text-gray-500">
							{formatFileSize(sizeBytes)}
						</span>
					) : null}
				</div>
				{status ? (
					<p className={`mt-0.5 text-xs capitalize ${statusClass}`}>
						{status}
						{error ? ` — ${error}` : ""}
					</p>
				) : null}
				{typeof progress === "number" ? (
					<div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-gray-100">
						<div
							className="h-full rounded-full bg-akgreen transition-all duration-200"
							style={{ width: `${Math.min(100, Math.max(0, progress))}%` }}
						/>
					</div>
				) : null}
			</div>
		</div>
	);
};

export default FileChip;
